/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateRowErrorRequestDto
 */
export interface UpdateRowErrorRequestDto {
    /**
     * 
     * @type {{ [key: string]: any | null; }}
     * @memberof UpdateRowErrorRequestDto
     */
    correctedRowData?: { [key: string]: any | null; } | null;
}

/**
 * Check if a given object implements the UpdateRowErrorRequestDto interface.
 */
export function instanceOfUpdateRowErrorRequestDto(value: object): value is UpdateRowErrorRequestDto {
    return true;
}

export function UpdateRowErrorRequestDtoFromJSON(json: any): UpdateRowErrorRequestDto {
    return UpdateRowErrorRequestDtoFromJSONTyped(json, false);
}

export function UpdateRowErrorRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateRowErrorRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'correctedRowData': json['correctedRowData'] == null ? undefined : json['correctedRowData'],
    };
}

export function UpdateRowErrorRequestDtoToJSON(json: any): UpdateRowErrorRequestDto {
    return UpdateRowErrorRequestDtoToJSONTyped(json, false);
}

export function UpdateRowErrorRequestDtoToJSONTyped(value?: UpdateRowErrorRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'correctedRowData': value['correctedRowData'],
    };
}

